/**
 * Vue i18n loader
 * created by @musnow
 * https://github.com/musnow
 */
import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const initLang = ['16', '17'].includes(process.env.VUE_APP_PLATFORM_TYPE)
  ? 'en-US'
  : 'zh-CN'

export const defaultLang = localStorage.getItem('language') || initLang

const messages = {}
const i18n = new VueI18n({
  locale: defaultLang,
  fallbackLocale: defaultLang,
  messages
})

export async function loadLanguageAsync (lang = defaultLang) {
  // 缓存语言设置
  if (!messages[lang]) {
    try {
      const langModule = await import(
        /* webpackChunkName: "lang-[request]" */ `./lang/${lang}`
      )

      const messageByLang = await langModule.default()

      messages[lang] = messageByLang
      i18n.setLocaleMessage(lang, messageByLang)
    } catch (e) {
      console.error('语言加载失败')
      console.log(e)
    }
  }

  return i18n
}

export function setI18nLanguage (lang) {
  localStorage.setItem('language', lang)
  i18n.locale = lang

  document.querySelector('html').setAttribute('lang', lang)
  return lang
}



// WEBPACK FOOTER //
// ./src/locales/index.js